// src/templates/AdminLayout.jsx
import { Outlet } from "react-router-dom";
import AdminTemplate from "../admin/layout/AdminTemplate";

export default function AdminLayout() {
  return (
    <AdminTemplate>
      <Outlet />
    </AdminTemplate>
  );
}
